<template>
<section class="px-3 rounded mt-3 mx-2" :style="{backgroundColor: props.list.bg_color}" v-if="props.list && props.list.items && props.list.items.length">
    <!-- desktop -->
    <div class="justify-content-between align-items-center py-1 rounded desktop-container">
        <div>
            <h6 class="mb-0" style="font-weight:600" :style="{color:props.list.color}">{{ props.list.name }}</h6>
            <small :style="{color:props.list.color}">{{ props.list.description ||' تخفیف های امروز در فروشگاه ' + props.list.items[0].store_place  }}</small>
        </div>
        <button @click="goWoleDamp" class="btn p-0" :style="{color:props.list.color}" style="font-size: small;">همه <i class="bi bi-arrow-left-circle"></i></button>
    </div>
    <div class="sc-1r3hge1-0 heMFVq scroll-example pb-0">
        <!-- mobile -->
        <div class="justify-content-around flex-column align-items-center pb-1 rounded mobile-container ml-1" style="width: 135px;min-width:135px !important">
            <div>
                <h6 class="mb-0" style="font-weight:600" :style="{color:props.list.color}">{{ props.list.name }}</h6>
                <small :style="{color:props.list.color}">تخفیف های امروز در فروشگاه {{ props.list.items[0].store_place }}</small>
            </div>
            <button @click="goWoleDamp" class="btn p-0" :style="{color:props.list.color}" style="font-size: small;">همه <i class="bi bi-arrow-left-circle"></i></button>
        </div>
        <product-template :list="props.list.items" />
    </div>
</section>
</template>
<script setup>
import { defineProps } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import ProductTemplate from '../../item/product.vue';
let route = useRoute()
let router = useRouter()
let props = defineProps(['list']);
function goWoleDamp(){
    router.push({name:'DampWholeBtn',params:{supplier_id:route.params.id}})
}
</script>

<style scoped>
i{
    vertical-align: middle;
}
.mobile-container{
    display: none;
}
.desktop-container{
    display: flex;
}
section{
    padding-top: .25rem;
    padding-bottom: 1rem;
}
@media (min-width:436px) {
    .desktop-container{
        display: none;
    }
    .mobile-container{
        display: flex;
    }
    section{
        padding-top: 1rem !important;
    }
}
small{
    font-size: small;
}
</style>